export default abstract class Entity {
    static fromOdata(odataItem: any, entity: Entity): Entity {
        return entity;
    }
}
